import Layout from 'utils/layout';

export default (element) => {
  const layout = Layout.getInstance();

  const resizeTextBox = () => {
    const cards = element.querySelectorAll('[data-listing-item]');
    if (layout.isBelowBreakpoint('lg')) {
      cards.forEach((card) => {
        const content = card.querySelector('.collection-listing__content');
        content.style.minHeight = '';
      });
      return;
    }
    // find the div.collection-listing__content with the largest height
    let maxHeight = 0;
    cards.forEach((card) => {
      const content = card.querySelector('.collection-listing__content');
      if (content.offsetHeight > maxHeight) {
        maxHeight = content.offsetHeight;
      }
    });

    // set all div.collection-listing__content to have the same height
    cards.forEach((card) => {
      const content = card.querySelector('.collection-listing__content');
      content.style.minHeight = `${maxHeight}px`;
    });
  };

  const init = () => {
    resizeTextBox();
    window.addEventListener('bpChange', resizeTextBox);
  };

  init();
};
